module.exports = __webpack_public_path__ + "static/media/LogicWheel6_1_continue_3.206e0b68.png";